import { useEffect, useState } from "react";
import {
  getDepartmentsApi,
  createDepartmentApi,
  deleteDepartmentApi,
  updateDepartmentApi
} from "../../app/api";
import {
  PencilSquareIcon,
  TrashIcon,
} from "@heroicons/react/24/outline";
import { createPortal } from "react-dom";
export default function Departments() {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    name: "",
    description: "",
  });

  const [deleteModal, setDeleteModal] = useState({ show: false, id: null });
  const [editModal, setEditModal] = useState({
    show: false,
    id: null,
    name: "",
    description: "",
  });

  const [responseModal, setResponseModal] = useState({
    show: false,
    success: true,
    message: "",
  });

  /* FETCH */
  const fetchDepartments = async () => {
    setLoading(true);
    const res = await getDepartmentsApi();
    if (res.success) setDepartments(res.data || []);
    setLoading(false);
  };

  useEffect(() => {
    fetchDepartments();
  }, []);

  /* CREATE */
  const handleCreate = async (e) => {
    e.preventDefault();

    const res = await createDepartmentApi(form);
    if (res.success) {
      setForm({ name: "", description: "" });
      fetchDepartments();
      setResponseModal({
        show: true,
        success: true,
        message: "Department added successfully",
      });
    } else {
      setResponseModal({
        show: true,
        success: false,
        message: res.message || "Failed to add department",
      });
    }
  };

  /* DELETE */
  const handleDelete = async () => {
    const res = await deleteDepartmentApi(deleteModal.id);

    if (res.success) {
      setDeleteModal({ show: false, id: null });
      fetchDepartments();
      setResponseModal({
        show: true,
        success: true,
        message: "Department deleted successfully",
      });
    }
  };

  /* EDIT */
  const handleEditSave = async () => {
    const payload = {
      name: editModal.name,
      description: editModal.description,
    };

    const res = await updateDepartmentApi(editModal.id, payload);

    if (res.success) {
      setEditModal({ show: false, id: null, name: "", description: "" });
      fetchDepartments();
      setResponseModal({
        show: true,
        success: true,
        message: "Department updated successfully",
      });
    }
  };





  const sortedDepartments = [...departments].sort((a, b) =>
    (a.name || "").toLowerCase().localeCompare((b.name || "").toLowerCase())
  );






  return (
    <>
      <div
        className="
        rounded-2xl
        md:mt-20
        p-5
      bg-[#12082F]
        text-white
        border border-white/10
        shadow-2xl shadow-[#12082F]/60
        relative
      "
      >
        {/* glow */}
        <div className="absolute -top-10 -right-10 w-60 h-60 bg-purple-500/20 blur-3xl rounded-full" />
        <div className="absolute bottom-0 -left-10 w-60 h-60 bg-fuchsia-500/20 blur-3xl rounded-full" />

        <h3 className="text-2xl font-bold  mb-4 relative z-10">
          Departments
        </h3>

        {/* CREATE FORM */}
        <form
          onSubmit={handleCreate}
          className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6 relative z-10"
        >
          <input
            placeholder="Department name"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            className="input-dark"
          />

          <input
            placeholder="Description"
            value={form.description}
            onChange={(e) =>
              setForm({ ...form, description: e.target.value })
            }
            className="input-dark "
          />


          <button
            type="submit"
            className="
                px-4 py-1.5 rounded-lg
                bg-purple-600 hover:bg-purple-500
                text-sm
              "
          >
            Add Department
          </button>
          {/* 
          <div className="md:col-span-3">
            <button
              type="submit"
              className="
                px-4 py-1.5 rounded-lg
                bg-purple-600 hover:bg-purple-500
                text-sm
              "
            >
              Add Department
            </button>
          </div> */}
        </form>

        {/* TABLE */}
        <div className="relative z-10 max-h-[360px] overflow-y-auto">
          <table className="w-full text-sm">
            <thead className="text-white/70">
              <tr className="border-b border-white/10">
                {/* <th className="py-2 text-left">ID</th> */}
                <th className="text-left">Name</th>
                <th className="text-left">Description</th>
                <th className="text-left">Actions</th>
              </tr>
            </thead>

            <tbody>
              {loading && (
                <tr>
                  <td colSpan="4" className="py-6 text-center opacity-60">
                    Loading...
                  </td>
                </tr>
              )}

              {!loading &&
                // departments.map((d) => (
                sortedDepartments.map((d) => (
                  <tr
                    key={d.id}
                    className="border-b border-white/5 hover:bg-white/5 transition"
                  >
                    {/* <td className="py-3">{d.id}</td> */}
                    <td className="font-medium">{d.name}</td>
                    <td className="opacity-80">{d.description}</td>

                    <td className="flex gap-3 py-3">
                      <button
                        onClick={() =>
                          setEditModal({
                            show: true,
                            id: d.id,
                            name: d.name,
                            description: d.description,
                          })
                        }
                        className="text-blue-300 hover:text-blue-400"
                      >
                        <PencilSquareIcon className="w-5 h-5" />
                      </button>

                      <button
                        onClick={() =>
                          setDeleteModal({ show: true, id: d.id })
                        }
                        className="text-red-300 hover:text-red-400"
                      >
                        <TrashIcon className="w-5 h-5" />
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>

        <div className="mt-3 text-xs opacity-60">
          Total Departments: {departments.length}
        </div>
      </div>

      {/* DELETE MODAL */}
      {/* {deleteModal.show && (
        <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center">
          <div className="bg-[#24155a] border border-white/20 rounded-xl p-6 w-full max-w-sm text-white">
            <h3 className="text-lg font-semibold mb-2">
              Delete Department?
            </h3>
            <p className="opacity-80 mb-4">
              Are you sure you want to delete this department?
            </p>

            <div className="flex gap-3">
              <button
                onClick={() =>
                  setDeleteModal({ show: false, id: null })
                }
                className="flex-1 py-2 bg-white/10 rounded-md"
              >
                Cancel
              </button>
              <button
                onClick={handleDelete}
                className="flex-1 py-2 bg-red-600 rounded-md"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )} */}







      {deleteModal.show &&
        createPortal(
          <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-md">

            <div
              className="
          relative
          w-full max-w-md
          p-8
          rounded-2xl
          bg-white/10
          backdrop-blur-xl
          border border-white/20
          shadow-[0_0_40px_rgba(0,0,0,0.6)]
          text-white
        "
            >
              {/* Glow border layer */}
              <div className="absolute inset-0 rounded-2xl border border-white/10 pointer-events-none"></div>

              <h3 className="text-xl font-semibold mb-3 tracking-wide">
                Delete Department
              </h3>

              <p className="text-sm text-white/70 mb-8">
                Are you sure you want to delete this department?
              </p>

              <div className="flex justify-end gap-4">
                <button
                  onClick={() =>
                    setDeleteModal({ show: false, id: null })
                  }
                  className="
              px-6 py-2 rounded-lg
              bg-white/20
              hover:bg-white/30
              transition-all duration-200
            "
                >
                  Cancel
                </button>

                <button
                  onClick={handleDelete}
                  className="
              px-6 py-2 rounded-lg
              bg-red-500/80
              hover:bg-red-600
              transition-all duration-200
            "
                >
                  Delete
                </button>
              </div>
            </div>
          </div>,
          document.body
        )}


      {/* EDIT MODAL */}
      {/* {editModal.show && (
        <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center">
          <div className="bg-[#24155a] border border-white/20 rounded-xl p-6 w-full max-w-sm text-white">
            <h3 className="text-lg font-semibold mb-3">
              Edit Department
            </h3>

            <input
              className="input-dark mb-3"
              value={editModal.name}
              onChange={(e) =>
                setEditModal({ ...editModal, name: e.target.value })
              }
            />

            <textarea
              rows={3}
              className="input-dark mb-4 resize-none"
              value={editModal.description}
              onChange={(e) =>
                setEditModal({
                  ...editModal,
                  description: e.target.value,
                })
              }
            />

            <button
              onClick={handleEditSave}
              className="w-full py-2 bg-purple-600 rounded-md mb-2"
            >
              Update
            </button>

            <button
              onClick={() =>
                setEditModal({
                  show: false,
                  id: null,
                  name: "",
                  description: "",
                })
              }
              className="w-full py-2 bg-white/10 rounded-md"
            >
              Cancel
            </button>
          </div>
        </div>
      )} */}






      {editModal.show &&
        createPortal(
          <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-md">

            <div
              className="
          relative
          w-full max-w-md
          p-8
          rounded-2xl
          bg-white/10
          backdrop-blur-xl
          border border-white/20
          shadow-[0_0_40px_rgba(0,0,0,0.6)]
          text-white
        "
            >
              {/* Soft glow layer */}
              <div className="absolute inset-0 rounded-2xl border border-white/10 pointer-events-none"></div>

              <h3 className="text-xl font-semibold mb-5 tracking-wide">
                Edit Department
              </h3>

              <input
                className="
            w-full mb-4 px-4 py-2 rounded-lg
            bg-white/15
            border border-white/20
            focus:outline-none
            focus:ring-2 focus:ring-purple-500/50
            placeholder:text-white/50
          "
                value={editModal.name}
                onChange={(e) =>
                  setEditModal({ ...editModal, name: e.target.value })
                }
                placeholder="Department Name"
              />

              <textarea
                rows={3}
                className="
            w-full mb-6 px-4 py-2 rounded-lg
            bg-white/15
            border border-white/20
            resize-none
            focus:outline-none
            focus:ring-2 focus:ring-purple-500/50
            placeholder:text-white/50
          "
                value={editModal.description}
                onChange={(e) =>
                  setEditModal({
                    ...editModal,
                    description: e.target.value,
                  })
                }
                placeholder="Description"
              />

              <div className="flex justify-end gap-4">
                <button
                  onClick={() =>
                    setEditModal({
                      show: false,
                      id: null,
                      name: "",
                      description: "",
                    })
                  }
                  className="
              px-6 py-2 rounded-lg
              bg-white/20
              hover:bg-white/30
              transition-all duration-200
            "
                >
                  Cancel
                </button>

                <button
                  onClick={handleEditSave}
                  className="
              px-6 py-2 rounded-lg
              bg-purple-600/80
              hover:bg-purple-700
              transition-all duration-200
            "
                >
                  Update
                </button>
              </div>
            </div>
          </div>,
          document.body
        )}








      {/* RESPONSE MODAL */}
      {responseModal.show && (
        <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center">
          <div className="bg-[#24155a] border border-white/20 rounded-xl p-6 w-full max-w-sm text-white">
            <h3
              className={`text-lg font-semibold mb-2 ${responseModal.success
                ? "text-green-400"
                : "text-red-400"
                }`}
            >
              {responseModal.success ? "Success" : "Error"}
            </h3>

            <p className="opacity-80 mb-4">
              {responseModal.message}
            </p>

            <button
              onClick={() =>
                setResponseModal({
                  show: false,
                  success: true,
                  message: "",
                })
              }
              className="w-full py-2 bg-purple-600 rounded-md"
            >
              OK
            </button>
          </div>
        </div>
      )}
    </>
  );
}
